import React from 'react';
import { Reveal } from './Reveal';
const rows = [{
  situation: 'Improvisar actividades cada semana',
  cost: 'Horas perdidas + oportunidades de conexión que no vuelven'
}, {
  situation: 'No saber qué decir en momentos de culpa',
  cost: 'Vínculo tenso, distancia emocional acumulada'
}, {
  situation: 'Fines de semana sin plan de conexión',
  cost: 'Tiempo libre que se va en pantallas y trámites'
}, {
  situation: 'Comparación constante con otros padres',
  cost: 'Desgaste emocional, autoestima parental baja'
}, {
  situation: 'Seguir posponiendo “cuando tenga más tiempo”',
  cost: 'Esta etapa de sus hijos no vuelve'
}];
export function CostOfInactionSection() {
  return <section aria-label="El costo de no tenerlo" className="w-full bg-cream-100 py-16 sm:py-24" data-id="element-36" data-mp="8bqa9micu5xd">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-37" data-mp="480nn2l8pyez">
        <Reveal data-id="element-38" data-mp="3vf3grzkn2eru">
          <h2 className="text-center font-display text-2xl font-semibold tracking-tight text-bark-900 sm:text-3xl" data-id="element-39" data-mp="3velaea49ik67">
            ¿Cuánto cuesta no tenerlo?
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-40" data-mp="30qn5esyfg9gn">
          <div className="mt-8 overflow-hidden rounded-3xl border border-bark-800/10 bg-cream-50 shadow-sm" data-id="element-41" data-mp="30qvgqgewj6pq">
            <table className="w-full border-collapse text-left" data-id="element-42" data-mp="2n09xgqljcurb">
              <caption className="sr-only" data-id="element-43" data-mp="2qziqtucnyqmc">Costo de seguir sin un sistema de presencia</caption>
              <thead data-id="element-44" data-mp="3epms3v2dqea6">
                <tr className="bg-bark-800" data-id="element-45" data-mp="3er67ljg7olaw">
                  <th scope="col" className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-cream-100 sm:px-6 sm:text-sm" data-id="element-46" data-mp="3jozdebdlrdan">
                    Lo que pasa hoy
                  </th>
                  <th scope="col" className="px-4 py-4 text-xs font-bold uppercase tracking-wider text-terracotta-300 sm:px-6 sm:text-sm" data-id="element-47" data-mp="3amygxgq70va1">
                    Lo que te cuesta
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-48" data-mp="4rkxv74qbzjz">
                {rows.map(row => <tr key={row.situation} className="border-t border-bark-800/[0.07]" data-id="element-49" data-mp="3vzgumw7sipar">
                    <th scope="row" className="px-4 py-4 align-top text-sm font-medium leading-snug text-bark-800 sm:px-6" data-id="element-50" data-mp="3r8h0fyq22lby">
                      {row.situation}
                    </th>
                    <td className="px-4 py-4 align-top text-sm leading-snug text-bark-600 sm:px-6" data-id="element-51" data-mp="3i9dhqvusw7xz">
                      {row.cost}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-52" data-mp="348sxrwd5g62w">
          <p className="mt-9 text-center font-display text-2xl font-semibold text-terracotta-600 sm:text-3xl" data-id="element-53" data-mp="349lvk7u4rl8w">
            La próxima semana puede ser diferente.
          </p>
        </Reveal>
      </div>
    </section>;
}